import {getWeatherImage} from "../../utils/utils";
import React from "react";
import styled from "styled-components";
import {Field} from "formik";

const SelectWeatherInputFormik = ({value}) => {
    return (
        <Container>
            <InputContainer>
                {["sunny", "cloudy", "rainy", "stormy"].map((w, index) => (
                    <label
                        key={index}>
                        <Field
                            type={"radio"}
                            name={'weather'}
                            value={w}
                            checked={value === w}
                        />
                        <WeatherCard>
                            <img src={getWeatherImage(w)} id={w} alt={`weather : ${w}`}/>
                        </WeatherCard>
                    </label>

                ))}
            </InputContainer>
        </Container>
    )
}

const Container = styled.div`

  gap: 1rem;
  align-items: center;
  justify-content: space-evenly;
  display: flex;
  flex-direction: column;
  width: 100%;
  @media (min-width: 768px) {
    width: unset;
  }
`
const WeatherCard = styled.div`
  display: flex;
  padding: 1em;
  background-color: var(--color-white);
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  margin: 1em 0;

  img {
    height: 3rem;
  }

  &:hover {
    background: var(--color-grey-03);
    cursor: pointer;
  }
`

const InputContainer = styled.div`
  display: grid;


  gap: 1em;

  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);

  label > input {
    opacity: 0;
    position: absolute;

  }

  label > input + div {
    display: flex;
    background-color: transparent;
    justify-content: space-evenly;
    align-items: center;
  }

  label > input:checked + div {
    background-color: var(--color-grey-03);
  }

  @media (min-width: 768px) {
    align-items: baseline;
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    justify-content: center;
    flex-wrap: wrap;
  }
`


export default SelectWeatherInputFormik